import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { FileInfo } from '@classes/file/file-info';
// import { FileProvider } from '@classes/file/file-provider';
import { FileUpload } from '@classes/file/file-upload';
// import { FileImport } from '@classes/file/file-import';
import { UiService } from './ui.service';
// import { FileSource } from '@enums/file-source.enum';
// import { FilesLists } from '@classes/file/files-lists';
// import { FileConfig } from '@classes/file/file-config';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    processingStateChanged = new Subject<boolean>();
    // filesListsChanged = new Subject<FilesLists>();

    private baseUrl = environment.apiUrl + 'extracted-file/upload-file';

    constructor(
        private http: HttpClient,
        private uiSrv: UiService
    ) { }

    uploadSimple(file: Blob, filename = 'file'): Observable<FileInfo> {
        const formData = new FormData();
        formData.append('file', file, filename);

        return this.http.post<FileInfo>(this.baseUrl, formData);
    }

    uploadWithProgress(file: FileUpload, pathParameter: string, provider: string, fileTemplateName: string): Observable<any> {
        const formData = new FormData();
        const fileName = file.file.name;
        formData.append('file', file.file, fileName);

        const httpParams = new HttpParams()
            .append('pathParameter', pathParameter)
            .append('provider', provider)
            .append('fileTemplateName', fileTemplateName);

        return this.http.post<any>(this.baseUrl, formData, {
            reportProgress: true,
            observe: 'events',
            params: httpParams
        }).pipe(
            map(event => this.processUploadEvent(event, file))
        );
    }

    // import(fileImport: FileImport): Observable<void> {
    //     this.processingStateChanged.next(true);

    //     return this.http.post<void>(`${this.baseUrl}/import`, fileImport)
    //     .pipe(
    //         tap(() => {
    //             this.processingStateChanged.next(false);
    //             this.uiSrv.showSnackbar('files.processingStates.success.fullLabel', true);
    //         })
    //     );
    // }

    // getFiles(): Observable<FilesLists> {
    //     this.uiSrv.loadingStateChanged.next(true);

    //     return this.http.get<FilesLists>(this.baseUrl)
    //     .pipe(
    //         tap(filesLists => {
    //             this.filesListsChanged.next(filesLists);
    //             this.uiSrv.loadingStateChanged.next(false);
    //         })
    //     );
    // }

    // getProviderFiles(): Observable<FileConfig[]> {
    //     const httpParams = new HttpParams()
    //         .append("source", FileSource.provider.toString());

    //     return this.http.get<FileConfig[]>(this.baseUrl, {params: httpParams});
    // }

    // getSimulationFiles(): Observable<FileConfig> {
    //     const httpParams = new HttpParams()
    //         .append("source", FileSource.simulation.toString());

    //     return this.http.get<FileConfig>(this.baseUrl, {params: httpParams});
    // }

    // getFilesProviders(): Observable<FileProvider[]> {
    //     return this.http.get<FileProvider[]>(`${this.baseUrl}/providers`);
    // }

    private processUploadEvent(event: HttpEvent<any>, file: FileUpload): any {
        switch(event.type) {
            case HttpEventType.UploadProgress:
                file.progress = Math.round(100 * event.loaded / event.total);
                break;
            case HttpEventType.Response:
                file.progress = 100;
                file.fileInfo = event.body;
                break;
        }

        return file;
    }
}
